import * as React from 'react'
import axios from 'axios'
import {
  Tabs,
  Descriptions,
  Row,
  Col,
  Form,
  Input,
  Select,
  message,
  Avatar,
  Upload,
} from 'antd'
import storageUtils from '@/utils/storageUtils'
import CommonUtils from '@/utils/commonUtils'
import config from '@/config/config'
import Urls from '@/config/url'
import https from '@/utils/ajaxUtils'
// import { UserOutlined, } from '@ant-design/icons';
import { connect } from 'react-redux'
const { TabPane } = Tabs
const { TextArea } = Input
const { Option } = Select
//需要渲染什么数据
function mapStateToProps(state) {
  return {
    userInfo: state,
  }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
  return {
    PayIncrease: v => dispatch({ type: 'change', value: v }),
  }
}
class Account extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loginInfo: JSON.parse(storageUtils.get(config.loginStorageKey)),
      userId: null,
      userInfo: null,
      username: '', //用户名
      activeKey: '1',
      confirmLoading: false,
      imageUrl: undefined,
      loading: false,
      serviceCount: '', //使用次数
    }
  }
  formRef = React.createRef()
  changePasformRef = React.createRef()
  componentWillMount() {
    // console.log(this.state.loginInfo);
    if (!this.state.loginInfo) {
      // 没有登陆
      // console.log('没有登陆');
    } else {
      if (
        this.state.loginInfo &&
        this.state.loginInfo.loginInfo &&
        this.state.loginInfo.loginInfo.userInfo
      ) {
        // console.log('1111111', this.state.loginInfo)
        this.setState(
          { userId: this.state.loginInfo.loginInfo.userInfo.id },
          () => {
            // console.log('userInfo', this.state.userInfo);
            this.getUserInfo(false)
          }
        )
      } else {
        // 没有获取到个人信息
        // console.log("没有获取到个人信息");
      }
    }
    // console.log('this.props.location', this.props.location)//传递过来的所有参数
    // console.log(this.props.location.state.key值)//val值
  }
  // 获取用户信息
  getUserInfo = async boo => {
    const res = await https.get(
      Urls.getUserInfo.replace('{id}', this.state.userId),
      {}
    )
    console.log(' 用户信息: ', res)
    this.setState({
      username: res?.data?.username,
      serviceCount: res.data?.extendFieldMap?.serviceCount,
    })
    if (!res.success) {
      message.error('获取用户信息失败!')
      return
    }
    this.setState({ userInfo: res.data }, () => {
      // console.log('用户信息', this.state.userInfo);
      this.formRef.current.setFieldsValue({
        mobile: this.state.userInfo.mobile,
      })
      this.formRef.current.setFieldsValue({ email: this.state.userInfo.email })
      // this.formRef.current.setFieldsValue({ username: this.getUserName() })
      if (this.state.userInfo.extendFieldMap) {
        this.formRef.current.setFieldsValue({
          education: this.state.userInfo.extendFieldMap.education,
        })
        this.formRef.current.setFieldsValue({
          PersonalProfile: this.state.userInfo.extendFieldMap.PersonalProfile,
        })
        this.formRef.current.setFieldsValue({
          position: this.state.userInfo.extendFieldMap.position,
        })
        this.formRef.current.setFieldsValue({
          researchField: this.state.userInfo.extendFieldMap.researchField,
        })
        this.setState({
          imageUrl: this.state.userInfo.extendFieldMap.avatarUrl,
        })
      }
      if (boo) {
        // 将改变后的用户信息存入token
        let loginInfo = this.state.loginInfo;
        loginInfo.loginInfo.userInfo = res.data;
        storageUtils.set(config.loginStorageKey, JSON.stringify(loginInfo));
        const { PayIncrease } = this.props
        PayIncrease(res.data)
        // this.props.history.push('/personal/account');
      }
    })
  }
  getUserName = () => {
    let userInfo = this.state.userInfo
    if (!userInfo) {
      return null
    }
    if (userInfo.username) {
      console.log(1)
      return userInfo.username
    }
    if (userInfo.mobile) {
      // console.log(2)
      // console.log(CommonUtils.getPhoneShow(userInfo.mobile, 3, 5))
      return CommonUtils.getPhoneShow(userInfo.mobile, 3, 5)
    }
    return null
  }
  tabChange = key => {
    this.setState({ activeKey: key }, () => {
      this.changePasformRef.current.setFieldsValue({ oldPassword: null })
      this.changePasformRef.current.setFieldsValue({ newPassword: null })
      this.changePasformRef.current.setFieldsValue({ confirmPassword: null })
    })
  }
  changeUserInfoCommit = () => {
    this.formRef.current
      .validateFields()
      .then(async values => {
        // success
        let userInfo = this.state.userInfo
        userInfo.mobile = values.mobile
        userInfo.email = values.email
        console.log('userInfo.extendFieldMap.serviceCount', userInfo.extendFieldMap.serviceCount)
        // userInfo.username = values.username
        let extendFieldMap = {
          education: values.education,
          PersonalProfile: values.PersonalProfile,
          position: values.position,
          researchField: values.researchField,
          avatarUrl: this.state.imageUrl,
          userType: userInfo.extendFieldMap.userType ? userInfo.extendFieldMap.userType : 0, //用户类型（默认个人）
          level: userInfo.extendFieldMap.level ? userInfo.extendFieldMap.level : 0, //用户等级
          serviceCount: userInfo.extendFieldMap.serviceCount ? userInfo.extendFieldMap.serviceCount : 0, //用户可使用服务次数
          integral: userInfo.extendFieldMap.integral ? userInfo.extendFieldMap.integral : 0, //积分
        }
        userInfo.extendFieldMap = extendFieldMap
        this.setState({ confirmLoading: true })
        const res = await https.put(Urls.updateUserInfo, userInfo)
        this.setState({ confirmLoading: false })
        if (res.success) {
          message.success('保存成功!')
          this.getUserInfo(true)
        } else {
          message.error(res.errMsg)
        }
      })
      .catch(errorInfo => {
        // error
        message.error('校验有误!')
      })
  }
  changePassCommit = () => {
    this.changePasformRef.current
      .validateFields()
      .then(async values => {
        // success
        this.setState({ confirmLoading: true })
        const res = await https.put(Urls.updatePasswordBySelf, values)
        this.setState({ confirmLoading: false })
        if (res.success) {
          message.success('保存成功!')
          this.tologinPage()
        } else {
          message.error(res.errMsg)
        }
      })
      .catch(errorInfo => {
        // error
        message.error('校验有误!')
      })
  }
  // 注销信息 跳转到登录页面
  tologinPage = () => {
    // 清空登录信息
    storageUtils.remove(config.loginStorageKey)

    // 返回登录页
    this.props.history.push(`/Login`)
  }
  customRequest = options => {
    let file = options.file
    console.log('file: ', file)
    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      message.error('请上传图片格式的文件')
      return
    }
    let formData = new FormData()
    formData.append('file', file)
    formData.append('bucketName', 'twirls-dev')
    let url = ''
    const apiMap = config.apiDomain
    const pageDomain = window.location.origin
    if (apiMap[pageDomain]) {
      url = apiMap[pageDomain] + '/minio-gateway/upload'
    } else {
      url = pageDomain + '/minio-gateway/upload'
    }
    // console.log('url: ', url)
    const loginInfoStr = JSON.parse(storageUtils.get(config.loginStorageKey))
    let headers = {
      'Content-Type': 'multipart/form-data',
    }
    headers[config.headerTokenKey] = loginInfoStr.token
    axios.post(url, formData, { headers: headers }).then(res => {
      // console.log('上传返回: ', res)
      if (res.data.code === '000000') {
        this.setState(
          {
            imageUrl:
              res.data && res.data.data && res.data.data.length > 0
                ? res.data.data[0]
                : null,
          },
          () => {
            console.log(this.state.imageUrl)
          }
        )
      } else {
        message.error('上传头像失败!')
        this.setState({ imageUrl: null })
        return
      }
    })
  }
  render() {
    const { loading, imageUrl } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }

    const formItemLayout2 = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const uploadButton = (
      <div>
        {loading ? (
          <Avatar
            size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
            // icon={<UserOutlined />}
            src="/img/default-avatar.png"
          />
        ) : (
          <Avatar
            size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
            // icon={<UserOutlined />}
            src="/img/default-avatar.png"
          />
        )}
        {/* <div style={{ marginTop: 8 }}>点击修改头像</div> */}
      </div>
    )

    return (
      <React.Fragment>
        <Tabs
          onChange={this.tabChange}
          activeKey={this.state.activeKey}
          className="personal-tabs"
        >
          <TabPane tab="资料设置" key="1">
            <div style={{ display: 'flex' }}>
              {/* 用户头像部分 */}
              <div
                align="middle"
                justify="center"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '30%',
                }}
              >
                <div>
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    showUploadList={false}
                    customRequest={option => this.customRequest(option)}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="avatar"
                        style={{ width: 80, height: 80, borderRadius: '50%' }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                  {/* <div
                    style={{
                      marginTop: 8,
                      fontFamily: 'MicrosoftYaHei',
                      color: 'rgba(0, 0, 0, 0.85)',
                      fontSize: '0.14rem',
                    }}
                  >
                    点击修改头像
                  </div> */}
                  <div>
                    <span
                      style={{
                        fontSize: '14px',
                        fontFamily: 'MicrosoftYaHeiSemibold',
                        color: 'rgba(51, 51, 51, 0.85)',
                        marginTop: '5px',
                      }}
                    >
                      用户id: {this.state.userId}
                    </span>
                    <img
                      src="/img/integral.png"
                      alt="身份标识"
                      style={{
                        width: '13px',
                        height: '13px',
                        marginLeft: '10px',
                      }}
                    />
                    <p
                      style={{
                        fontSize: '12px',
                        color: 'rgba(102, 102, 102, 0.85)',
                      }}
                    >
                      剩余次数：<span>{this.state.serviceCount}</span>
                    </p>
                  </div>
                </div>
              </div>
              {/* 用户信息部分 */}
              <div
                className="table-container"
                style={{
                  display: 'flex',
                  width: '70%',
                  overflowY: 'auto',
                  marginTop: 0,
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div style={{ width: '8rem' }}>
                    <Row style={{ height: 'auto' }}>
                      <Form
                        name="addForm"
                        ref={this.formRef}
                        {...formItemLayout}
                        initialValues={
                          {
                            // 'mobile': this.state.userInfo?.mobile,
                            // 'email': this.state.userInfo?.email,
                            // 'username': getUserName(),
                          }
                        }
                      >
                        <Row>
                          <Col span={24}>
                            <Descriptions title="用户基本信息"></Descriptions>
                            <Row>
                              <Col span={12}>
                                <Form.Item
                                  label="手机号码"
                                  name="mobile"
                                  rules={
                                    [
                                      // {
                                      //   required: true, message: '请输入手机号码', whitespace: true,
                                      // }
                                    ]
                                  }
                                >
                                  <Input
                                    allowClear
                                    placeholder="请输入手机号码"
                                    disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  label="邮箱"
                                  name="email"
                                  rules={[
                                    {
                                      pattern:
                                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                      message: '请输入合法邮箱!',
                                    },
                                  ]}
                                >
                                  <Input allowClear placeholder="请输入邮箱" />
                                </Form.Item>
                              </Col>
                              {/* <Col span={12}>
                                <Form.Item
                                  label="用户名称"
                                  name="username"
                                  rules={[
                                    {
                                      required: true,
                                      message: '请输入用户名称',
                                      whitespace: true,
                                    },
                                  ]}
                                >
                                  <Input
                                    allowClear
                                    placeholder="请输入用户名称"
                                  />
                                </Form.Item>
                              </Col> */}
                              <Col span={12}>
                                <Form.Item label="学历信息" name="education">
                                  {/* <Input allowClear placeholder="请输入学历信息" /> */}
                                  <Select
                                    allowClear
                                    placeholder="请选择学历信息"
                                  >
                                    <Option value="博士研究生">
                                      博士研究生
                                    </Option>
                                    <Option value="硕士研究生">
                                      硕士研究生
                                    </Option>
                                    <Option value="本科">本科</Option>
                                    <Option value="专科">专科</Option>
                                    <Option value="高中">高中</Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={24}>
                                <Form.Item
                                  label="个人简介"
                                  name="PersonalProfile"
                                  {...formItemLayout2}
                                >
                                  <TextArea
                                    maxLength={50}
                                    allowClear
                                    showCount={(count, maxLength) => {
                                      return count + '/' + maxLength
                                    }}
                                    placeholder="请输入个人简介"
                                    autoSize={{ minRows: 3, maxRows: 3 }}
                                  />
                                </Form.Item>
                              </Col>
                              {/* </Form> */}
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Descriptions title="用户其他信息"></Descriptions>
                            {/* <Form name="addForm" ref={this.formRef} style={{ maxHeight: '5.5rem', overflow: 'auto' }} {...formItemLayout}> */}
                            <Row>
                              <Col span={12}>
                                <Form.Item
                                  label="职位"
                                  name="position"
                                  rules={[
                                    {
                                      required: true,
                                      message: '职位',
                                    },
                                  ]}
                                >
                                  <Select allowClear placeholder="请选择职位">
                                    <Option value="教授">教授</Option>
                                    <Option value="副教授">副教授</Option>
                                    <Option value="助理教授">助理教授</Option>
                                    <Option value="研究员">研究员</Option>
                                    <Option value="副研究员">副研究员</Option>
                                    <Option value="助理研究员">
                                      助理研究员
                                    </Option>
                                    <Option value="博士后">博士后</Option>
                                    <Option value="博士生">博士生</Option>
                                    <Option value="研究生">研究生</Option>
                                    <Option value="其他">其他</Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  label="研究领域"
                                  name="researchField"
                                >
                                  <Input
                                    allowClear
                                    placeholder="请输入研究领域"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24} align="center">
                            <div
                              className="actionSelf"
                              onClick={() => {
                                this.changeUserInfoCommit()
                              }}
                              style={{ bottom: '0.65rem', width: '3.8rem' }}
                            >
                              <div className="buttonSelf">保存</div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tab="密码修改" key="2">
            <div className="table-container">
              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <div className="table-logo"></div>
                <div className="table-text">用户基本信息</div>
              </div> */}

              <Row align="middle" style={{ marginTop: '0.15rem' }}>
                <Form
                  name="addForm"
                  ref={this.changePasformRef}
                  style={{
                    maxHeight: '5.5rem',
                    minHeight: '5.5rem',
                    overflow: 'auto',
                    marginLeft: '0.2rem',
                  }}
                  {...formItemLayout}
                >
                  <Form.Item
                    label="旧密码"
                    name="oldPassword"
                    rules={[
                      {
                        required: true,
                        message: '请输入原密码',
                        whitespace: true,
                      },
                      {
                        pattern:
                          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/,
                        message: '8位到12位,首字母+数字',
                      },
                    ]}
                  >
                    <Input.Password allowClear placeholder="请输入原密码" />
                  </Form.Item>
                  <Form.Item
                    label="新密码"
                    name="newPassword"
                    rules={[
                      {
                        required: true,
                        message: '请输入新密码',
                        whitespace: true,
                      },
                      {
                        pattern:
                          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/,
                        message: '8位到12位,首字母+数字',
                      },
                    ]}
                  >
                    <Input.Password allowClear placeholder="请输入新密码" />
                  </Form.Item>
                  <Form.Item
                    label="确认密码"
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    rules={[
                      {
                        required: true,
                        message: '请输入确认密码',
                        whitespace: true,
                      },
                      {
                        pattern:
                          /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,12}$/,
                        message: '8位到12位,首字母+数字',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue('newPassword') === value
                          ) {
                            return Promise.resolve()
                          }
                          return Promise.reject(
                            new Error('密码跟确认密码不一致!')
                          )
                        },
                      }),
                    ]}
                  >
                    <Input.Password allowClear placeholder="请输入确认密码" />
                  </Form.Item>
                  {/* <div style={{ textAlign: 'center' }}>
                    <Button type="primary" style={{ width: '3rem' }} onClick={this.changePassCommit} loading={this.state.confirmLoading}>保存</Button>
                  </div> */}
                  <div
                    className="actionSelf"
                    onClick={() => {
                      this.changePassCommit()
                    }}
                  >
                    <div
                      className="buttonSelf"
                      style={{ minWidth: '2.5rem', marginLeft: '10%' }}
                    >
                      保存
                    </div>
                  </div>
                </Form>
              </Row>
            </div>
          </TabPane>
        </Tabs>
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account)
